export const isStringInArray = (arr, str) => {
    // Normalize the string: trim extra spaces and convert to lowercase
    const normalizedStr = str.trim().toLowerCase();

    // Check if the normalized string exists in the normalized array
    return arr.some((item) => item.trim().toLowerCase() === normalizedStr);
};
